import { Address } from './address';
import { Contact } from './contact';

export class ContactDetails {
  CurrentValue?: string;
  Contacts: Contact[] = [];
  Addresses: Address[] = [];
}